// action types
import { createRequestTypes } from "../../utils";

// Fetch Pending Ingredients
export const FETCH_PENDING_INGREDIENTS = createRequestTypes("FETCH_PENDING_INGREDIENTS");

export const fetchPendingIngredientsRequest = () =>
    ({ type: FETCH_PENDING_INGREDIENTS.REQUEST });

export const fetchPendingIngredientsSuccess = (data) =>
    ({ type: FETCH_PENDING_INGREDIENTS.SUCCESS, payload: { data } });

export const fetchPendingIngredientsFailure = (error) =>
    ({ type: FETCH_PENDING_INGREDIENTS.FAILURE, payload: error });

// Approve Ingredient
export const APPROVE_INGREDIENT = createRequestTypes("APPROVE_INGREDIENT");

export const approveIngredientRequest = (ingredient_id, notes) =>
    ({ type: APPROVE_INGREDIENT.REQUEST, payload: { ingredient_id, notes } });

export const approveIngredientSuccess = () =>
    ({ type: APPROVE_INGREDIENT.SUCCESS });

export const approveIngredientFailure = (error) =>
    ({ type: APPROVE_INGREDIENT.FAILURE, payload: { error } });

// Reject Ingredient
export const REJECT_INGREDIENT = createRequestTypes("REJECT_INGREDIENT");

export const rejectIngredientRequest = (ingredient_id, notes) =>
    ({ type: REJECT_INGREDIENT.REQUEST, payload: { ingredient_id, notes } });

export const rejectIngredientSuccess = () =>
    ({ type: REJECT_INGREDIENT.SUCCESS });

export const rejectIngredientFailure = (error) =>
    ({ type: REJECT_INGREDIENT.FAILURE, payload: { error } });

// Promote Ingredient to Global
export const PROMOTE_INGREDIENT = createRequestTypes("PROMOTE_INGREDIENT");

export const promoteIngredientRequest = (ingredient_id, notes) =>
    ({ type: PROMOTE_INGREDIENT.REQUEST, payload: { ingredient_id, notes } });

export const promoteIngredientSuccess = () =>
    ({ type: PROMOTE_INGREDIENT.SUCCESS });

export const promoteIngredientFailure = (error) =>
    ({ type: PROMOTE_INGREDIENT.FAILURE, payload: { error } });
